export default __webpack_public_path__ + "static/media/Users-Roles.33845f67.svg";